import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { MagnifyingGlass, Archive } from "@phosphor-icons/react";
import { useAuth } from "@/context/AuthContext";

export function ToolBar({ search, onSearch, status, onStatus, statusOptions, children, placeholder = "Search...", searchTestId = "search-input", showArchived, onToggleArchived }) {
  const { user } = useAuth();
  const isAdmin = user?.role === "admin";
  return (
    <div className="flex flex-wrap gap-3 items-center border-b border-border pb-4">
      <div className="relative flex-1 min-w-[200px] max-w-md">
        <MagnifyingGlass size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground" />
        <Input
          value={search}
          onChange={(e) => onSearch(e.target.value)}
          placeholder={placeholder}
          className="pl-9 border-border"
          data-testid={searchTestId}
        />
      </div>
      {statusOptions && (
        <Select value={status || "all"} onValueChange={(v) => onStatus(v === "all" ? "" : v)}>
          <SelectTrigger className="w-[160px] border-border" data-testid="status-filter">
            <SelectValue placeholder="Status" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All statuses</SelectItem>
            {statusOptions.map((s) => (
              <SelectItem key={s.value} value={s.value}>{s.label}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
      {isAdmin && onToggleArchived && (
        <button
          type="button"
          onClick={() => onToggleArchived(!showArchived)}
          data-testid="toggle-archived"
          className={`inline-flex items-center gap-2 border rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
            showArchived
              ? "border-amber-300 bg-amber-50 text-amber-900"
              : "border-border bg-card text-muted-foreground hover:text-foreground"
          }`}
        >
          <Archive size={14} weight={showArchived ? "fill" : "regular"} />
          {showArchived ? "Showing archived" : "View archived"}
        </button>
      )}
      <div className="ml-auto flex gap-2">{children}</div>
    </div>
  );
}
